module.exports = __webpack_public_path__ + "img/hea_team_psychology.0c2916cb.png";